import React from 'react';
import {twMerge} from 'tailwind-merge';

type KeyboardHintProps = {
  keys: string | readonly string[];
  text?: string;
  alreadyNightAware?: boolean;
};

export const KeyboardHint = ({
  keys,
  text,
  alreadyNightAware,
}: KeyboardHintProps) => {
  const keysArr = typeof keys === 'string' ? keys.split('+') : keys;

  return (
    <div
      className={twMerge(
        'flex items-center gap-8',
        // must not add "night-aware" class if already in a night-aware
        // container, otherwise they'll cancel each other out
        !alreadyNightAware && 'night-aware'
      )}>
      <span className={'text-moon-800 dark:text-moon-200'}>{text}</span>
      <div className="flex items-center justify-end gap-2">
        {keysArr.map((hint, index) => (
          <div
            key={index}
            className={twMerge(
              'rounded px-6 py-2 text-sm',
              'bg-oblivion/[0.07] text-moon-600 dark:bg-moonbeam/[0.12] dark:text-moon-400'
            )}>
            {hint}
          </div>
        ))}
      </div>
    </div>
  );
};

/**
 * Our tooltips have a dark background by default. Wrapping with a
 * "night-mode" container ensures light/dark colors are inverted.
 */
export const KeyboardHintInTooltip = (props: KeyboardHintProps) => {
  return (
    <div className="night-mode">
      <KeyboardHint {...props} alreadyNightAware />
    </div>
  );
};
